import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoencaHistoricoListaComponent } from './doenca-historico-lista/doenca-historico-lista.component';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { DoencaListaComponent } from './doenca-lista/doenca-lista.component';
import { DoencaInsercaoComponent } from './doenca-insercao/doenca-insercao.component';
import { DoencaInativacaoComponent } from './doenca-inativacao/doenca-inativacao.component';
import { DoencaReativacaoComponent } from './doenca-reativacao/doenca-reativacao.component';
import { DoencaAtualizacaoComponent } from './doenca-atualizacao/doenca-atualizacao.component';
import { PanelModule } from '../libs/panel/panel.module';
import { TabAllModule } from '@syncfusion/ej2-angular-navigations';
import { ButtonAllModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { SplitButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { AxSelectModule } from '../libs/ax-select/ax-select.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';
import { DatePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { CompartilhadoModule } from '../compartilhado/compartilhado.module';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { LightInfoModule } from '../libs/light-info/light-info.module';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';



@NgModule({
  declarations: [
    DoencaHistoricoListaComponent,
    DoencaListaComponent,
    DoencaInsercaoComponent,
    DoencaInativacaoComponent,
    DoencaReativacaoComponent,
    DoencaAtualizacaoComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorHandlerModule,
    DatePickerAllModule,
    TextBoxAllModule,
    GridAllModule,
    RichTextEditorAllModule,
    DropDownListAllModule,
    CheckBoxAllModule,
    DialogAllModule,
    TabAllModule,
    ButtonAllModule,
    SplitButtonAllModule,
    AxSelectModule,
    CompartilhadoModule,
    LightInfoModule,
    PanelModule
  ],
  exports: [
    DoencaHistoricoListaComponent,
    DoencaListaComponent
  ]
})
export class DoencaModule { }
